<script>
import {defineComponent} from 'vue'
import moment from "moment";

export default defineComponent({
  name: "RangePicker",
  props:{
    quarter:String,
    value:Array,
    format:{
      type:String,
      default:'YYYY-MM-DD'
    },

  },
  methods:{
    handleDateClick(value){
      if (value){
        this.$emit('panelChange',[null,moment(value)])
      }else {
        this.$emit('panelChange',[])
      }

    },
    formatTime(time){
      return moment(time).format(this.format)
    }
  },
  data(){
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    }
  }
})
</script>

<template>
  <div style="display: inline-block">
    <div style="display: flex;justify-content:space-between;width: 360px;align-items: center;border: 1px solid #DCDFE6;padding: 0 15px;border-radius: 4px;">
      <div style="display: flex;width: 150px;cursor: not-allowed;flex-shrink: 0">
        <span style="color: #cdd0d7" v-if="value[0]">
          {{formatTime(value[0])}}
        </span>
        <span style="color: #e3e3e3" v-else>
          请先选择结束日期
        </span>
      </div>
      <div>~</div>
      <el-date-picker
        style="width: 150px"
        :value="value[1]"
        prefix-icon=""
        type="year"
        placeholder="选择结束日期"
        @input="handleDateClick"
        :picker-options="pickerOptions"
      >
      </el-date-picker>

  <!--    <a-range-picker-->
  <!--      style="width: 360px"-->
  <!--      :mode="quarter"-->
  <!--      :placeholder="['请先选择结束日期', '结束日期']"-->
  <!--      :value="companyInfo.time"-->
  <!--      format="YYYY"-->
  <!--      @panelChange="timeChange"-->
  <!--      @change="handleTimeRangeChange"-->
  <!--    >-->
  <!--    </a-range-picker>-->
    </div>
  </div>
</template>

<style scoped lang="stylus">
:deep(){
  .el-input__prefix{
    display none;
  }
  //.el-icon-date{
  //  display none;
  //}
  .el-input__inner{
    border 0 none
    //padding-left 15px
  }
}
</style>
